import { render, staticRenderFns } from "./TciTitle.vue?vue&type=template&id=58cde004"
import script from "./TciTitle.vue?vue&type=script&lang=js"
export * from "./TciTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports